// YouTube 24/7 streams. Channels restart them under new video IDs, so dead IDs need replacing from time to
// time; each needs a matching station_thumb_<id>.gif in public/gifs and on R2 (see README).
// The first station is the default for new visitors, so keep the most stable stream there.
// Never add Lofi Girl streams: they sent lofi.cafe a cease and desist. scripts/check-stations.sh enforces it.
const stations = [
  {
    id: "5yx6BWlEVcY",
    name: "Chillhop Radio - jazzy & lofi hip hop beats 🐾",
  },
  {
    id: "7NOSDKb0HlU",
    name: "lofi hip hop radio - beats to study/relax to 🐾",
  },
  {
    id: "blAFxjhg62k",
    name: "Coffee Shop Radio - 24/7 Chill Lo-Fi & Jazzy Beats",
  },
  {
    id: "TfmECBzmOn4",
    name: "Lofi Hip Hop Radio 🍉 Relaxing Beats to Study, Sleep, Chill to",
  },
  {
    id: "lkcjlTqmoDY",
    name: "videogame lofi & chill beats 💾 pixel art backgrounds",
  },
  {
    id: "i6WzngxTnBA",
    name: "late night vibes radio - calm lofi / dreamy beats 😴",
  },
  {
    id: "UedTcufyrHc",
    name: "ChillSynth FM - lofi synthwave radio for retro dreaming",
  },
  {
    id: "FWjZ0x2M8og",
    name: "lofi hip hop radio 😴 sad & sleepy beats",
  },
  {
    id: "qH3fETPsqXU",
    name: "【24/7 CHILL LOFI HIP HOP RADIO】beats to sleep/relax/study to",
  },
  {
    id: "BLIKwfIJIyo",
    name: "Space Ambient Music LIVE 24/7: Ambient Cosmic Background for Sleep",
  },
];

export default stations;
